import { css } from 'linaria';

export const bannerList = css`
  && {
    display: flex;

    li {
      column-gap: 8px;
    }

    @media (--only-mobile) {
      flex-direction: column;
    }

    li:not(:last-child) {
      margin-right: 24px;
      margin-bottom: 0;

      @media (--only-mobile) {
        margin-right: 0;
        margin-bottom: 16px;
      }
    }
  }
`;
